<script>
  import { M } from '../../../external';

  export let onClick;
  export let type;

  let icon = 'error_outline';
  let message = M.ERROR;
  let title = M.ERROR;
  let border = '';
  let disabled = false;

  const handleOptionClick = () => {
    if (disabled) return;
    onClick();
  };

  $: {
    if (!icon || !type) {
      icon = 'error_outline';
      message = M.ERROR;
      title = M.ERROR;
    }

    switch (type) {
      case 'DELAY':
        icon = 'schedule';
        title = M.DELAY;
        border = 'blue-border';
        message = M.DELAY_DESC;
        break;
      case 'IF_ELSE':
        icon = 'help_outline';
        title = M.IFELSE;
        border = 'blue-border';
        message = M.IFELSE_DESC;
        break;
      case 'SPLIT':
        icon = 'call_split';
        title = M.SPLIT;
        border = 'blue-border';
        message = M.SPLIT_DESC;
        disabled = true;
        break;
      case 'TARGET':
        icon = 'flag';
        title = M.TARGET;
        border = 'blue-border';
        message = M.TARGET_DESC;
        disabled = true;
        break;
      case 'SEND_EMAIL':
        icon = 'mail_outline';
        title = M.SEND_EMAIL;
        message = M.SEND_EMAIL_DESC;
        break;
      case 'SEND_EMAIL_NOTIFICATION':
        icon = 'notification_important';
        title = M.SEND_EMAIL_NOTIFICATION;
        message = M.SEND_EMAIL_NOTIFICATION_DESC;
        break;
      case 'SEND_SMS':
        icon = 'sms';
        title = M.SEND_SMS;
        message = M.SEND_SMS_DESC;
        break;
      case 'SEND_WHATSAPP':
        icon = 'whatsapp';
        title = M.SEND_WHATSAPP;
        message = M.SEND_WHATSAPP_DESC;
        break;
      case 'SEND_VOICE':
        icon = 'voice_chat';
        title = M.SEND_VOICE;
        message = M.SEND_VOICE_DESC;
        break;
      case 'CONTACT_TAG_ADD':
        icon = 'label';
        title = M.CONTACT_TAG_ADD;
        message = M.CONTACT_TAG_ADD_DESC;
        break;
      case 'CONTACT_TAG_REMOVE':
        icon = 'label_off';
        title = M.CONTACT_TAG_REMOVE;
        message = M.CONTACT_TAG_REMOVE_DESC;
        break;
      case 'CONTACT_PROPERTY_CHANGE':
        icon = 'assignment_ind';
        title = M.CONTACT_PROPERTY_CHANGE;
        message = M.CONTACT_PROPERTY_CHANGE_DESC;
        break;
      case 'CONTACT_NOTE_ADD':
        icon = 'sticky_note_2';
        title = M.CONTACT_NOTE_ADD;
        message = M.CONTACT_NOTE_ADD_DESC;
        break;
      case 'CONTACT_DELETE':
        icon = 'person_remove';
        title = M.CONTACT_DELETE;
        message = M.CONTACT_DELETE_DESC;
        break;
      case 'CONTACT_LIST_ADD':
        icon = 'person_add';
        title = M.CONTACT_LIST_ADD;
        message = M.CONTACT_LIST_ADD_DESC;
        break;
      case 'CONTACT_LIST_REMOVE':
        icon = 'person_remove';
        title = M.CONTACT_LIST_REMOVE;
        message = M.CONTACT_LIST_REMOVE_DESC;
        break;
      case 'CONTACT_MEMBER_GROUP_ADD':
        icon = 'person_add';
        title = M.CONTACT_MEMBER_GROUP_ADD;
        message = M.CONTACT_MEMBER_GROUP_ADD_DESC;
        break;
      case 'CONTACT_MEMBER_GROUP_REMOVE':
        icon = 'person_remove';
        title = M.CONTACT_MEMBER_GROUP_REMOVE;
        message = M.CONTACT_MEMBER_GROUP_REMOVE_DESC;
        break;
      case 'CONTACT_UNSUBSCRIBE':
        icon = 'person_remove';
        title = M.CONTACT_UNSUBSCRIBE;
        message = M.CONTACT_UNSUBSCRIBE_DESC;
        break;
      case 'START_AUTOMATION':
        icon = 'autorenew';
        title = M.OTHER_ANOTHER_START;
        message = M.OTHER_ANOTHER_START_DESC;
        break;
      case 'END_AUTOMATION':
        icon = 'exit_to_app';
        title = 'End This Automation';
        message = '';
        disabled = true;
        break;
      case 'TRIGGER_WEBHOOK':
        icon = 'link';
        title = M.OTHER_WEBHOOK_TRIGGER;
        message = '';
        break;
      case 'CONTACT_LMS_ENROLL':
        icon = 'input';
        title = M.ACTION_ENROLL_TO_CIRCLE;
        message = M.ACTION_ENROLL_TO_CIRCLE_DESC;
        break;
      case 'CONTACT_LMS_UNENROLL':
        icon = 'output';
        title = M.ACTION_UNENROLL_FROM_CIRCLE;
        message = M.ACTION_UNENROLL_FROM_CIRCLE_DESC;
        break;

      default:
        icon = 'error_outline';
        title = M.ERROR;
        message = M.ERROR;
        break;
    }
  }
</script>

{#if !disabled}
  <li>
    <div on:click={handleOptionClick} class={"add-automation-rule flex align-center" + (disabled ? " automation-rule-disabled" : "")}>
      {#if icon === 'whatsapp'}
      <span class="circle-automation-icon">
        <svg style="width:26px; height: 26px; padding: 6px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 124 124"
             viewBox="0 0 124 124" id="whatsapp">
          <path fill="#3d3f4b" fill-rule="evenodd"
                d="M64,15.8c-25.5,0-46.2,20.7-46.2,46.2c0,9,2.5,17.6,7.4,25.1l-7,15.5 c-0.6,1.4-0.4,3.1,0.6,4.3c0.8,0.9,1.9,1.4,3.1,1.4c0.4,0,0.7,0,1.1-0.1l19.4-5.3c6.7,3.6,14.2,5.5,21.8,5.5 c25.5,0,46.2-20.7,46.2-46.2C110.2,36.5,89.5,15.8,64,15.8z M64,100.2c-6.8,0-13.4-1.8-19.2-5.2c-0.6-0.4-1.3-0.6-2-0.6 c-0.4,0-0.7,0-1.1,0.1L29,98l4.4-9.7c0.6-1.3,0.4-2.9-0.4-4c-4.7-6.5-7.2-14.2-7.2-22.3C25.8,41,43,23.8,64,23.8 c21,0,38.2,17.1,38.2,38.2C102.2,83,85.1,100.2,64,100.2z"
                clip-rule="evenodd"></path>
          <path fill="#3d3f4b" fill-rule="evenodd"
                d="M81.8,68.9c-1.9-1.2-4.5-2.5-6.7-1.5c-1.7,0.7-2.9,3.5-4,4.9c-0.6,0.7-1.3,0.8-2.2,0.5 c-6.6-2.6-11.6-7-15.2-13c-0.6-0.9-0.5-1.7,0.2-2.6c1.1-1.3,2.5-2.8,2.8-4.5c0.3-1.7-0.5-3.8-1.2-5.3c-0.9-2-1.9-4.8-3.9-5.9 c-1.8-1-4.2-0.5-5.8,0.9c-2.8,2.3-4.2,5.9-4.1,9.4c0,1,0.1,2,0.4,3c0.6,2.3,1.6,4.5,2.9,6.6c0.9,1.6,1.9,3.1,3,4.5 c3.5,4.8,7.9,8.9,12.9,12c2.5,1.5,5.3,2.9,8.1,3.8c3.2,1,6,2.1,9.4,1.5c3.6-0.7,7.1-2.9,8.5-6.3c0.4-1,0.6-2.2,0.4-3.2 C86.6,71.3,83.6,70,81.8,68.9z"
                clip-rule="evenodd"></path>
        </svg>
      </span>
      {:else if icon === 'voice_chat'}
        <span class="circle-automation-icon">
          <svg style="padding: 9px; width: 22px; height: 22px;" xmlns="http://www.w3.org/2000/svg" height="24px"
               viewBox="0 -960 960 960" width="24px" fill="#3d3f4b">
            <path
              d="M240-520h60v-80h-60v80Zm100 80h60v-240h-60v240Zm110 80h60v-400h-60v400Zm110-80h60v-240h-60v240Zm100-80h60v-80h-60v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"></path>
          </svg>
        </span>
      {:else}
        <span class="circle-automation-icon {border}"
              class:material-icons-outlined={icon !== 'input'}
              class:material-icons={icon === 'input'}> {icon} </span>
      {/if}
      <div>
        <h5>{title}</h5>
        {#if message}
          <span class="col20 f-left light-gray-text t-left mt-5">{message}</span>
        {/if}
      </div>
    </div>
  </li>
{/if}
